import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { T as Text } from '../../Text/Text-CO4HftGt.js';

const PageStatus = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40026394__sc-fxn3rh-0"
})(["display:flex;align-items:center;"]);
PageStatus.displayName = 'PageStatus';
const PaginationPageStatus = ({
  currentPageLabel,
  size = 'base',
  ...rest
}) => /*#__PURE__*/React__default.createElement(PageStatus, _extends({}, rest, {
  size: size
}), currentPageLabel);

export { PaginationPageStatus as P };
//# sourceMappingURL=PaginationPageStatus-Djsre6ij.js.map
